import axios from 'axios'

export default class Api {
	constructor () {
		this.base = process.env.VUE_APP_API_BASE
		this.joinStr = ''
	}

	/**
	 * api > get endpoint
	 * @param {String} path エンドポイントのパス
	 * @return {String} [return description]
	 */
	endpoint (path) {
		const { base, joinStr } = this
		const endpoint = [base, path].join(joinStr)
		return endpoint
	}

	/**
	 * api > get bearer option
	 * @param {String} token トークン(ID token)
	 * @param {Object} option オプション
	 * @return {Object} [return description]
	 */
	setBearerOption (token, option) {
		option = option || {}
		option.headers = option.headers || {}
		option.headers.Authorization = `Bearer ${token}`
		return option
	}

	/**
	 * api > get
	 * @param {String} endpoint エンドポイント
	 * @param {Object} option リクエストオプション
	 * @return {Promise} [return description]
	 */
	get (endpoint, option) {
		option = option || {}
		const deferred = new Promise((resolve, reject) => {
			axios.get(endpoint, option)
				.then(res => {
					return resolve(res.data)
				})
				.catch(err => {
					return reject(err.response)
				})
		})
		return deferred
	}

	/**
	 * api > post
	 * @param {String} endpoint エンドポイント
	 * @param {Object} body リクエストボディ
	 * @param {Object} option リクエストオプション
	 * @return {Promise} [return description]
	 */
	post (endpoint, body, option) {
		body = body || {}
		option = option || {}
		const deferred = new Promise((resolve, reject) => {
			axios.post(endpoint, body, option)
				.then(res => {
					return resolve(res.data)
				})
				.catch(err => {
					return reject(err.response)
				})
		})
		return deferred
	}

	/**
	 * api > put
	 * @param {String} endpoint エンドポイント
	 * @param {Object} body リクエストボディ
	 * @param {Object} option リクエストオプション
	 * @return {Promise} [return description]
	 */
	put (endpoint, body, option) {
		body = body || {}
		option = option || {}
		const deferred = new Promise((resolve, reject) => {
			axios.put(endpoint, body, option)
				.then(res => {
					return resolve(res.data)
				})
				.catch(err => {
					return reject(err.response)
				})
		})
		return deferred
	}

	/**
	 * api > patch
	 * @param {String} endpoint エンドポイント
	 * @param {Object} body リクエストボディ
	 * @param {Object} option リクエストオプション
	 * @return {Promise} [return description]
	 */
	patch (endpoint, body, option) {
		body = body || {}
		option = option || {}
		const deferred = new Promise((resolve, reject) => {
			axios.patch(endpoint, body, option)
				.then(res => {
					return resolve(res.data)
				})
				.catch(err => {
					return reject(err.response)
				})
		})
		return deferred
	}

	/**
	 * api > delete
	 * @param {String} endpoint エンドポイント
	 * @param {Object} option リクエストオプション
	 * @return {Promise} [return description]
	 */
	delete (endpoint, option) {
		option = option || {}
		const deferred = new Promise((resolve, reject) => {
			axios.delete(endpoint, option)
				.then(res => {
					return resolve(res.data)
				})
				.catch(err => {
					return reject(err.response)
				})
		})
		return deferred
	}
}
